import SearchResult from '@components/Boss/SearchResult';
import StoreInfo from '@components/Boss/StoreInfo';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CloseSVG from '@images/svg-icons/x-close.svg';
import Select from 'react-select';
import { getLabelFallback } from '@utils/utils';
import * as actions from '@redux-actions/';
import Loader from '@components/Loader';


const BossModal = props => {
  const showSearchResult = useSelector((state) => state.cart.physicalStores);
  const selectedStore = useSelector((state) => state.cart.selectedStore);
  const radius = useSelector((state) => state.cart.radius);
  const isMobile = useSelector((state) => state.cart.isMobile);
  const dispatch = useDispatch();
  const [filterLoading, setfilterLoading] = useState(false);

  const customStyles = {
    control: base => ({
      ...base,
      height: 30,
      minHeight: 30,
      width: 120,
      minWidth: 120,
    }),
    singleValue: base => ({
      ...base,
      height: 40,
      minHeight: 40,
      width: 100,
    }),
    indicatorsContainer: base => ({
      ...base,
      height: 30,
      minHeight: 30,
    }),
    indicatorSeparator: () => ({ display: 'none' }),
  };

  const selectMode = {
    isSearchable: false,
    options: [
      { value: '50', label: '50 miles' },
      { value: '100', label: '100 miles' },
      { value: '150', label: '150 miles' },
    ],
  };

  useEffect(() => {
    setfilterLoading(false);
}, [selectedStore]);    

  return (
    <div className="modal-container">
      <div className="modal-overlay" onClick={props.onClose}></div>
      <div className="modalBoss">
        <div className="modalBoss-header container-fluid-boss">
          <div className="modalBoss-header-right">
            <div className="modalBoss-header-right-top">
                <div className="modalBoss-header-right-title">
                {getLabelFallback('TITLE_STORE_LOCATOR_MODAL_LABEL')}
                </div>
                <div className="modalBoss-header-right-select">
                <Select
                    onChange={e => {
                      window?.tealium_data2track.push({
                        id: 'Click',
                        data_element_id: 'X_X_StoreLocator_ChangeDistance'
                      })
                      dispatch(actions.setRadius(e.value));
                      setfilterLoading(true);
                    }}
                    classNamePrefix="mySelect"
                    styles={customStyles}
                    {...selectMode}
                    defaultValue={{ value: radius, label: radius + ' miles' }}
                />
                <Loader classes={"filter-loader" + (filterLoading ? " show" : " hide")}/>
                </div>
            </div>
            <div className="modalBoss-header-right-subtitle">
                { getLabelFallback('SUBTITLE_STORE_LOCATOR_MODAL_LABEL') }
            </div>
          </div>
          <div className="modalBoss-header-left row">
            <CloseSVG
              width={'18px'}
              height={'18px'}
              viewBox={'0 0 24 24'}
              data_analytics-available-call='0'
              onClick={() => props.onClose()}
            />
          </div>
        </div>
        <div className="modalBoss-center">
          {!isMobile &&
            <div className="modalBoss-left">
              <div className="container">
                <div className="row search-result-container">
                  <div className="container-row search-result">
                    {showSearchResult && <SearchResult />}
                  </div>
                </div>
              </div>
            </div>
          }
          
          <div className="modalBoss-right">
            <div className="container modalBoss-right-inner">
              <div className="row">
                <div className="store-info">
                  <StoreInfo config={props.config} />
                </div>
              </div>
            </div>
          </div>
          {isMobile && 
            <div className="modalBoss-mobile">
              <div className="container-row search-result">
                {showSearchResult && <SearchResult deliverHere={props.deliverHere} />}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default BossModal;


